import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { RegiaoMultiselectComponent } from './regiao-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        RegiaoMultiselectComponent
    ],
    exports: [
        RegiaoMultiselectComponent
    ]
})
export class RegiaoMultiselectModule { }
